import {organisation} from './organisation';
import {packCountryDomain} from './packCountryDomain';

export const subscription = function (item = null) {
    return {
        id: item == null ? null : item.id,
        startDate: item == null ? null : item.startDate,
        endDate: item == null ? null : item.endDate,
        organisation: organisation(item == null ? null : item.organisation),
        packCountryDomain: packCountryDomain(item == null ? null : item.packCountryDomain),
        isPayed: item == null ? false : item.isPayed,
        price: item == null ? 0 : item.price,
        payedPrice: item == null ? 0 : item.payedPrice,
        tva: item == null ? 0 : item.tva,
        voucher: item == null ? 0 : item.voucher,
        currency: item == null ? '' : item.currency,
        decimalDigits: item == null ? 0 : item.decimalDigits
    };
};
